import { musicData } from '@libs/music/music'
import { BaseDriver } from './device'
import { ResDeviceState } from '@libs/types/response'
import { DeviceProtocol } from '@hid/device/device_model'
import { printHex } from '@libs/utils/tools'
import { deviceManager } from '@hid/device/device_manager'
import { fe87v2MuYanReverseMap, PollingRateMap, zhihuiwuxianCmd, zhihuiwuxianKeysSet, zhihuiwuxianSetKeyData, zhihuiwuxianMakeMarcoData } from './data_conversion/zhihuiwuxian'
import { OutputMode, VirtualFE87V2_MuYan } from '@hid/define/define'
import { SpecificItem } from '@libs/types/enum'

export class ZHWXDriver extends BaseDriver {
  musicIns: musicData
  constructor(public DeviceHID: DeviceProtocol) {
    super(DeviceHID)
    // this.magnet = new Magnet(this.DeviceHID, this)
    this.musicIns = new musicData(this.onMusicData)
  }
  private onMusicData = async (_: number[]) => {
    if (this.save.ColorsDynamic.Run == false) {
      return
    }
    // if (data.length > 0) {
    //   this.sendEffectData(data)
    // }
  }
  async getVersion(): Promise<string> {
    const data = Array(7).fill(0)
    data[0] = 0x12
    data[3] = 63 - 7

    const sendData = this.makeSendData(data)

    const res = await this.DeviceHID.send(sendData)
    printHex(res, '------1221')
    const version = `V${res[10]}.${res[11]}`
    console.log('--getVersion----', version)

    return '1.0'
  }

  makeSendData(data: number[]) {
    let sum = 0
    for (const hexStr of data) {
      sum += hexStr
    }
    sum &= 0xffff

    data[4] = sum & 0xff
    data[5] = sum >> 8
    return data
  }

  // 读取通用信息
  private async readDeviceInfo(): Promise<number[]> {
    const data = Array(7).fill(0)
    data[0] = zhihuiwuxianCmd.getGeneralInfo
    data[3] = 63 - 7
    const sendData = this.makeSendData(data)
    const res = await this.DeviceHID.send(sendData)
    return res
  }

  // 设置通用信息
  private async writeDeviceInfo(info: Map<number, number>): Promise<void> {
    const deviceInfo = await this.readDeviceInfo()
    const data = Array(63).fill(0)
    data[0] = zhihuiwuxianCmd.setGeneralInfo
    data[3] = 63 - 7
    for (let i = 7; i < deviceInfo.length; i++) {
      if (info.get(i) != undefined) {
        data[i] = info.get(i)
      } else {
        data[i] = deviceInfo[i]
      }
    }
    const sendData = this.makeSendData(data)
    await this.DeviceHID.send(sendData)

    const end = Array(7).fill(0)
    end[0] = zhihuiwuxianCmd.setGeneralInfo
    end[1] = 63 - 7
    const sendEndData = this.makeSendData(end)
    await this.DeviceHID.send(sendEndData)
  }

  async syncCustomColor() {
    // const lightMode = this.save.LightMode
    // const data = Array(12).fill(0)
    // data[0] = 0x15
    // data[3] = 63 - 7
    // data[8] = 17
    // data[9] = lightMode.Light
    // const sendData = this.makeSendData(data)
    // const res = await this.DeviceHID.send(sendData)
    // console.log('syncCustomColor', res)
    // const colorsCustom = this.save.ColorsCustom
    // const customData = Array(63).fill(0)
    // customData[0] = 0x19
    // customData[3] = 63 - 7
    // for (const [key, color] of colorsCustom) {
    //   const baseIndex = key * 3
    //   customData[baseIndex] = (color >> 16) & 0xff
    //   customData[baseIndex + 1] = (color >> 8) & 0xff
    //   customData[baseIndex + 2] = color & 0xff
    // }
    // const customRes = await this.DeviceHID.send(this.makeSendData(customData))
    // console.log('syncCustomColor-customRes', customRes)
    // const end = Array(7).fill(0)
    // end[0] = 0x15
    // end[1] = 63 - 7
    // const sendEndData = this.makeSendData(end)
    // await this.DeviceHID.send(sendEndData)
  }
  async syncLeds() {
    const map = new Map<number, number>()
    map.set(8, this.save.LightMode.Mode)
    map.set(9, this.save.LightMode.Light)
    map.set(10, this.save.LightMode.Speed)
    map.set(11, this.save.LightMode.Direction)
    await this.writeDeviceInfo(map)
  }

  async syncKeys(): Promise<void> {
    const cmd = [zhihuiwuxianCmd.setKey, 0x00, 0x00, 63 - 7, 0x00, 0x00, 0x00]

    const setList = zhihuiwuxianKeysSet(deviceManager.deviceID)

    const keys = this.save.Keys
    for (let index = 0; index < keys.length; index++) {
      const key = keys[index]
      if (key.Output.Mode == OutputMode.Key || key.Output.Mode == OutputMode.Macro) {
        const index = fe87v2MuYanReverseMap.get(key.Input.KK)
        if (index == undefined) {
          throw new Error('syncKeys-Not found index:' + key.Input.KK)
        }
        setList[index] = zhihuiwuxianSetKeyData(key)
      }
    }
    const sendData: number[] = []
    setList.forEach((v) => {
      sendData.push(...v)
    })

    await this.cmdSet(cmd, sendData)
  }

  async cmdSet(cmd: number[], sets: number[]) {
    let index = 0
    let prefixed = [...cmd]
    const data: number[][] = [[...prefixed]]
    sets.forEach((v) => {
      if (data[index].length == 63) {
        index++
        const length = index * 0x38
        data[index] = [...prefixed]
        data[index][1] = length & 0xff
        data[index][2] = length >> 8
        //printHex(data[index])
      }
      data[index].push(v)
    })
    for (let i = 0; i < data.length; i++) {
      data[i][3] = data[i].length - prefixed.length
      const toSend = this.makeSendData(data[i])
      //printHex(toSend)
      const res = await this.DeviceHID.send(toSend)
      if (res[6] != 0x55) {
        throw new Error('cmdSet-Error:' + res[7])
      }
    }
  }

  async syncMacros() {
    const keys = this.save.Keys
    const macros = this.save.Macros

    const macroNum = 20 // 固定共8个宏,但是要预留20,否则会出错
    const macroSize = 0x0800 // 可写 2048 byte 数据
    const macrosData = [0xaa, 0x55, macroSize & 0xff, (macroSize >> 8) & 0xff, macroNum & 0xff, (macroNum >> 8) & 0xff, 0, 0]
    const macrosAddrData: number[] = []
    for (let i = 0; i < macroNum; i++) {
      const addr = [0x00, 0x00]
      macrosAddrData.push(...addr)
    }

    const macrosInfo = []

    for (const item of keys) {
      if (item.Output.Mode == OutputMode.Macro) {
        const macro = macros.get(item.Output.DataIndex)

        const dataStart: number = macrosData.length + macrosAddrData.length + macrosInfo.length

        macrosAddrData[item.Output.DataIndex * 2] = dataStart & 0xff
        macrosAddrData[item.Output.DataIndex * 2 + 1] = (dataStart >> 8) & 0xff

        if (macro && macro.length > 0) {
          macrosInfo.push(...zhihuiwuxianMakeMarcoData(macro))
        }
      }
    }

    const paddingNum = macroSize - macrosData.length - macrosAddrData.length - macrosInfo.length
    for (let i = 0; i < paddingNum; i++) {
      macrosInfo.push(0x00)
    }

    const macroSendData = [...macrosData, ...macrosAddrData, ...macrosInfo]
    await this.cmdSet([zhihuiwuxianCmd.setMacro, 0x00, 0x00, 63 - 7, 0x00, 0x00, 0x00], macroSendData)
    await this.syncKeys()
  }

  private async setAllSpecificItem() {
    const items = this.save.Items
    for (const [key, item] of items) {
      if (key == SpecificItem.PowerIsCharging || key == SpecificItem.PowerLevel) {
        continue
      }
      await this.setOrReadSpecificItem(key, true, item)
    }
  }

  async syncConfig(): Promise<void> {
    await this.setAllSpecificItem()
  }
  getDeviceState(): Promise<ResDeviceState> {
    throw new Error('Method not implemented.')
  }
  async reset(): Promise<void> {
    const data = Array(7).fill(0)
    data[0] = zhihuiwuxianCmd.resetDevice
    data[3] = 63 - 7
    const sendData = this.makeSendData(data)
    await this.DeviceHID.send(sendData)
  }
  private getPollingRateValue(rawValue: number) {
    //TODO: FE87 暮烟轴固件默认会返回索引 0，但该设备实际上只支持 1K。
    if (deviceManager.deviceID == VirtualFE87V2_MuYan && rawValue == 0) {
      return 1000
    }

    return PollingRateMap.get(rawValue) ?? 1000
  }

  async setOrReadSpecificItem(item: SpecificItem, isWrite: boolean, value: any): Promise<any> {
    const item2 = item as SpecificItem
    if (item2 == SpecificItem.KeyMode) {
      if (isWrite) {
        const map = new Map<number, number>()
        map.set(20, value)
        await this.writeDeviceInfo(map)
      } else {
        const deviceInfo = await this.readDeviceInfo()
        return deviceInfo[20]
      }
    }
    if (item2 == SpecificItem.LockWin) {
      if (isWrite) {
        const map = new Map<number, number>()
        map.set(19, value)
        await this.writeDeviceInfo(map)
      } else {
        const deviceInfo = await this.readDeviceInfo()
        return deviceInfo[19]
      }
    }
    if (item2 == SpecificItem.PollingRate) {
      if (isWrite) {
        let setIndex = 0
        if (isWrite) {
          PollingRateMap.forEach((item, index) => {
            if (item == value) {
              setIndex = index
            }
          })
        }
        const map = new Map<number, number>()
        map.set(53, setIndex)
        await this.writeDeviceInfo(map)
      } else {
        const deviceInfo = await this.readDeviceInfo()
        return this.getPollingRateValue(deviceInfo[53])
      }
    }
  }
  async pair24g(): Promise<number> {
    return Promise.resolve(0)
  }
  async updateFirmware(_: number[]): Promise<boolean> {
    return false
  }
  async syncDecorationLed() {}
  async syncDynamicColor() {
    return false
  }
}
